// Presentation only: what currency an amount *is* comes from the backend; nothing here guesses or converts.
// The web port of leazepro_ds currency.dart; keep the two in step.

export type DsCompactStyle = 'international' | 'indian'

const SYMBOLS: Record<string, string> = {
  INR: '₹',
  USD: '$',
  EUR: '€',
  GBP: '£',
  AED: 'AED\u00A0',
  SGD: 'S$',
  AUD: 'A$',
  CAD: 'C$',
  MYR: 'RM\u00A0',
}

/** Unknown codes fall back to the code itself ("SGD 1,200"): a rupee for an unknown currency would be a lie. */
export function currencySymbol(code?: string | null): string {
  if (!code) return SYMBOLS.INR
  return SYMBOLS[code.toUpperCase()] ?? `${code.toUpperCase()}\u00A0`
}

// Grouping follows the money, not the reader: 12,34,567 for rupees in any interface, 1,234,567 for
// dollars even in Mumbai. A caller wanting the reader's own convention passes an explicit locale.
export function currencyLocale(code?: string | null): string {
  return (code ?? 'INR').toUpperCase() === 'INR' ? 'en-IN' : 'en-US'
}

/** Lakh/crore for rupees, K/M/B elsewhere. */
export function currencyCompactStyle(code?: string | null): DsCompactStyle {
  return (code ?? 'INR').toUpperCase() === 'INR' ? 'indian' : 'international'
}
